export const LOGO = 'logo';

export const NON_FIELD_ERRORS = 'non_field_errors';
export const UNKNOWN_ERROR_OCCURED = 'Unknown error occurred';
